import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector } from "react-redux";
function RightMenu({ children, status, close }) {
  const datas = useSelector((v) => v.rtl);

  return (
    <>
      <Offcanvas
        show={status}
        onHide={close}
        className={"pyment"}
        // onHide={() => dispatch(RightOffClear())}
        placement="end"
      >
        {/* <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header> */}
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default RightMenu;
